import * as React from 'react';
var SvgStopperTriangle = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12 4 6 16H6l6-16Z"
}));
export default SvgStopperTriangle;